export default __webpack_public_path__ + "static/media/connection.b944faf5.svg";